  <div class="loader-parent add-note-container">
    <div class="page-loader" [ngClass]="{ 'd-none': !isLoading }"></div>
    <!-- Modal body -->
    <div class="modal-body">
      <div class="quotes-model-inner">
        <h2>{{productsRow?.sample_packing_image?.length > 0 ? 'Preview' : 'Capture'}} Sample Image</h2>
        <div class="attchment-note-form">
            <div class="project-gallery-drop">
              @if(productsRow?.sample_packing_image?.length > 0) {
                <div class="sample-image-custom-class">
                  <img [src]="displaySampleImage()" />
                </div>
              } @else {
                <div class="drop-zone drop-zone-height" (click)="startWebcam()">
                  <div class="drop-zone-min upload-file" *ngIf="!isWebcamStarted || isPermissionAccessDenied">
                    <span class="drop-zone__prompt">
                      Click here to capture the sample image.</span>
                  </div>
                  <div class="webcam-container" *ngIf="isWebcamStarted && !isPermissionAccessDenied">
                    <video width="100%" *ngIf="!isPictureTaken" #video autoplay playsinline></video>
                    <canvas #canvas style="display:none;"></canvas>
                    <img *ngIf="isPictureTaken" [src]="capturedImage" class="captured-image"/>
                  </div>
                </div>
              }
            </div>
        </div>
        <div class="web-cam-btn" *ngIf="videoStream && isWebcamStarted">
          <button class="actionBtn capture-image-btn" (click)="takePicture()" *ngIf="!isPictureTaken">Take Picture</button>
          <button class="actionBtn capture-image-btn" (click)="switchCamera()" *ngIf="!isPictureTaken">Switch camera</button>
        </div>
        <div class="web-cam-btn" *ngIf="isPictureTaken">
          <button class="actionBtn capture-image-btn" (click)="retakePicture()">Retake Picture</button>
        </div>
      </div>
    </div>
    <div class="modal-footer w-100">
      <a class="btn grey-bordered-btn grey-bg-btn" href="javascript:;" data-dismiss="modal"
      (click)="ngbActiveModal.close()">Cancel</a>
    <button *ngIf="(!productsRow.sample_packing_image || (productsRow.sample_packing_image && productsRow.sample_packing_image.length == 0))" class="btn grey-bg-btn add-note-btn" [disabled]="!capturedImage || !isPictureTaken"
       (click)="uploadSampleImage()">Upload</button>
     </div>
  </div>
